export function isHttps(protocol: string) {
  return protocol.startsWith('https');
}

export const emailReg = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/i;
